export type TextFilters = string[];

const SEARCH_TERMS_TOKEN_REGEX = /([\w-]+)|("[^"]+")/g;

export const NULL_TEXT_FILTERS: TextFilters = [];

export function applyTextFilter(filters: TextFilters, text: string): boolean {
  if (filters.length > 0) {
    const lowerCaseText = text.toLowerCase();
    return filters.some((filter) => lowerCaseText.includes(filter));
  }
  return true;
}

export function applyTextFilters<T>(
  filters: TextFilters,
  items: T[],
  getText: (item: T) => string
): T[] {
  if (filters.length > 0) {
    return items.filter((item) => applyTextFilter(filters, getText(item)));
  }
  return items;
}

export type SearchText = string | null | undefined;
export function tokeniseSearchText(searchText?: SearchText): TextFilters {
  return (
    (searchText || "").toLowerCase().match(SEARCH_TERMS_TOKEN_REGEX) || NULL_TEXT_FILTERS
  ).map((t) => t.replace(/"/g, ""));
}
